@if (!isSupplierContent) {
    @if (!isEcommerceContent) {
        <div class="wrapper" *ngIf="(isLoggedIn && !isStandAlonePage)">
            <app-side-bar></app-side-bar>
            <app-message-toast></app-message-toast>
            <div class="main overflow-hidden">
                <div class="notification-bar p-5 align-items-center pt-0 pb-0 d-flex left-0 right-0 z-[10] flex-[0_1_auto]">
                    <i class="bi bi-save absolute z-[99] left-[1rem]" *ngIf="showOpenSideBarIcon"></i>
                    <div class="notification-content d-flex justify-content-between align-items-center w-100">
                        <div class="d-flex align-items-center"></div>
                        <div class="notif-elements d-flex gap-4 align-items-center dropdown-container machship-notif-container">
                            <div class="dropdown w-[30px] machship-dropdown" >
                                <div class="machship-dropdownheader" (click)="isDropdownVisibleMachshipNotif = !isDropdownVisibleMachshipNotif">
                                    <i class="bi bi-bell"></i>
                                    <span *ngIf="availableTransactions.length" class="badge text-bg-danger absolute right-0 cursor-pointer">{{ availableTransactions.length }}</span>
                                </div>
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end !inset-[auto_0px_auto_auto]" [ngClass]="{'show': isDropdownVisibleMachshipNotif, 'hide-notif': !isDropdownVisibleMachshipNotif}">
                                    <div class="dropdown-menu-header">
                                        <div class="position-relative machship-notif-header">
                                            {{ availableTransactions.length ? availableTransactions.length + ' New Orders' : 'No Available Orders' }}
                                        </div>
                                    </div>
                                    <div class="list-group" [ngClass]="{'machship-notif': availableTransactions.length > 5}">
                                        <a *ngFor="let transaction of availableTransactions" href="javascript:void(0)" class="list-group-item hover:bg-gray-100" (click)="onOpenRosterRoute(transaction)">
                                            <div class="g-0 align-items-center">
                                                <div class="col ps-2">
                                                    <div class="font-[600] text-[#575757] text-[16px]">{{ transaction.roster_start_date | date: 'dd MMM YYYY' }}</div>
                                                    <div class="text-muted small mt-1 !text-[#1565D8] text-[14px]">{{ transaction.client }}</div>
                                                    <div class="text-muted small mt-1 text-[#6C757D] text-[12px]">{{ transaction.stop_details[0]?.address }}</div>
                                                    <div class="text-muted small mt-1 text-[10px]"><span class="text-[#6C757D]">Consignment Number</span>: <strong>{{ transaction.stop_details[0]?.consignment_number }}</strong></div>
                                                    <div class="text-muted small mt-1 text-[10px]"><span class="text-[#6C757D]">Consignment Tracking Number</span>: <strong>{{ transaction.stop_details[0]?.consignment_tracking_number }}</strong></div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="showRegistrationBell" class="dropdown w-[30px] machship-dropdown registration-notif-container">
                                <div class="machship-dropdownheader registration-dropdownheader" (click)="onToggleRegistrationDropdown()" title="New company registrations">
                                    <i class="bi bi-building bell-shake" [ngClass]="{'has-notif': hasNewRegistration}"></i>
                                    <span *ngIf="recentRegistrations.length" class="badge text-bg-danger absolute right-0 cursor-pointer">{{ recentRegistrations.length }}</span>
                                </div>
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end !py-0 !inset-[auto_0px_auto_auto]" [ngClass]="{'show': isDropdownVisibleRegistrationNotif, 'hide-notif': !isDropdownVisibleRegistrationNotif}">
                                    <div class="dropdown-menu-header">
                                        <div class="position-relative machship-notif-header">
                                            @if (isFetchingRegistrations) {
                                                <span class="loading-ellipsis">Preparing data&nbsp;</span>
                                            } @else {
                                                {{ recentRegistrations.length ? recentRegistrations.length + ' Company Registrations' : 'No Registrations Yet' }}
                                            }
                                        </div>
                                    </div>
                                    <div class="list-group" [ngClass]="{'machship-notif': recentRegistrations.length > 5}">
                                        <a *ngFor="let registration of recentRegistrations; let lastItem = last" href="javascript:void(0)" class="list-group-item hover:bg-gray-100" (click)="openRegistration(registration)" [ngClass]="{'!border-b-0': lastItem}">
                                            <div class="g-0 align-items-center">
                                                <div class="col ps-2">
                                                    <div class="font-[600] text-[#575757] text-[16px]">{{ registration.name }}</div>
                                                    <div class="text-muted small mt-1 !text-[#1565D8] text-[14px]">{{ registration.contactName || registration.email || '—' }}</div>
                                                    <div class="text-muted small mt-1 text-[10px]" *ngIf="registration.createdAt">{{ registration.createdAt | date: 'dd MMM YYYY, h:mm a' }}</div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <span class="user-name">{{ (authDetails.first_name ?? '-') + ' ' + (authDetails.last_name ?? '-') }}</span>
                            <div class="relative">
                                <!-- Click icon to toggle state -->
                                <i class="bi bi-chevron-down cursor-pointer" (click)="toggleProfileSetting()"></i>

                                <!-- Show menu conditionally based on component state -->
                                @if (isShowProfileSetting) {
                                    <div class="dropdown-menu absolute !inset-[auto_0px_auto_auto] !p-[2px_0] block">
                                        <button type="button" class="dropdown-item" (click)="switchToPortalAuth(); isShowProfileSetting = false">
                                            <i class="fa-solid fa-truck-front !text-[12px] !text-[#265973]"></i> Customer Portal
                                        </button>
                                        <button type="button" class="dropdown-item" (click)="onSignOut(); isShowProfileSetting = false">
                                            <i class="fa-solid fa-arrow-right-from-bracket fa-sm !text-[12px] align-middle !text-[#265973]"></i> Sign out
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <main class="content relative custom-scrollbar flex-[1_1_auto] overflow-y-scroll">
                    <div class="container-fluid p-0 h-full">
                        <router-outlet></router-outlet>
                    </div>
                </main>
            </div>
        </div>
    }

    <div class="flex-grow-1">
        @if(isStandAlonePage) {
            <router-outlet></router-outlet>
        }
    </div>

    @if (isEcommerceContent && !isStandAlonePage) {
        <div class="wrapper ecommerce-wrapper">
            <div class="main overflow-hidden">
                <main class="relative ecommerce-scroll flex-[1_1_auto] overflow-y-auto">
                    <div class="container-fluid p-0 h-full">
                        <router-outlet></router-outlet>
                    </div>
                </main>
            </div>
        </div>
    }
    <router-outlet name="invalid-page"></router-outlet>

    <ngx-loading [show]="isLoading"></ngx-loading>

    <!-- In-app call screen and SMS chat - live above every page so they survive navigation. -->
    <app-call-console></app-call-console>
    <app-sms-chat-console></app-sms-chat-console>
    <!-- CRM stage questions (asked before a card moves) - see StageGateService. -->
    <app-stage-gate-modal></app-stage-gate-modal>
} @else {
    <router-outlet></router-outlet>
    <app-toast-container></app-toast-container>
}